export function sortByProp(prop, reverse) {
    return (a, b) => {
        let objA = a[prop];
        let objB = b[prop];
        if (reverse) {
            objA = objB;
            objB = a[prop];
        }
        if (objA < objB) {
            return -1;
        }
        if (objA > objB) {
            return 1;
        }
        // names must be equal
        return 0;
    };
}
